import { Dialog } from 'primereact/dialog';
import { useEffect, useState } from 'react';
import { MinimizedLvCatalog } from '../../../Helper/ApiHelper/LvEpNetworkHelper';
import BeeButton from '../../Atoms/BeeButton';
import AlphaLvCatalogPickerStep from './AlphaLvCatalogPickerStep';

type AlphaLvCatalogSelectDialogProps = {
  visible: boolean;
  catalogs: Record<string, MinimizedLvCatalog[]>;
  header?: string;
  readOnly?: boolean;
  onHide: () => void;
  onConfirm?: (selection: MinimizedLvCatalog) => void;
  epCatalogVersionId?: string;
};

export default function AlphaLvCatalogSelectDialog({
  visible,
  catalogs,
  header = 'LV-Katalog auswählen',
  readOnly = false,
  onHide,
  onConfirm,
  epCatalogVersionId
}: AlphaLvCatalogSelectDialogProps) {
  const [selected, setSelected] = useState<MinimizedLvCatalog | null>(null);

  function handleConfirm() {
    if (!selected || !onConfirm) return;
    onConfirm({
      ...selected
    });
  }

  return (
    <Dialog
      header={header}
      visible={visible}
      modal={true}
      className={'bee-dialog-large bee-dialog-primary'}
      onHide={() => onHide()}
    >
      <AlphaLvCatalogPickerStep
        readOnly={readOnly}
        catalogs={catalogs}
        selected={selected}
        epCatalogVersionId={epCatalogVersionId}
        onSelectionChange={(row) => setSelected(row)}
      />

      <div className={'flex justify-content-end gap-2 mt-3'}>
        {readOnly ? (
          <BeeButton
            type={'primary'}
            label={'Schließen'}
            onClick={() => onHide()}
          />
        ) : (
          <>
            <BeeButton
              type={'secondary'}
              label={'Abbrechen'}
              onClick={() => onHide()}
            />
            <BeeButton
              type={'primary'}
              label={'Übernehmen'}
              disabled={!selected}
              onClick={() => void handleConfirm()}
            />
          </>
        )}
      </div>
    </Dialog>
  );
}
